<template>
  <div class="landing">
    <section class="hero">
      <h1 class="greeting">
        <span class="hi">{{ $t("hello") }} {{ firstName }}!</span>
        <span class="today">&nbsp;{{ $t("today_is") }} {{ todayWeekday }}, {{ todayFull }}</span>
      </h1>
      <div class="search" v-if="false">
        <div class="search-box">
          <i class="icon-search"></i>
          <input v-model.trim="q" type="text" :placeholder="$t('common.search')" @keyup.enter="onSearch" />
          <button class="filter-btn" @click="onOpenFilters"></button>
        </div>
      </div>
    </section>

    <section
      v-if="visibleShortcuts[0].length"
      class="shortcuts"
      :style="{ gridTemplateColumns: 'repeat(' + visibleShortcuts[0].length + ', minmax(160px, 1fr))' }"
    >
      <router-link
        v-for="item in visibleShortcuts[0]"
        :key="item.href"
        :is="canAccess(item) ? 'router-link' : 'div'"
        :to="canAccess(item) ? item.href : null"
        class="shortcut-card"
        :class="{ 'shortcut-card--disabled': !canAccess(item) }"
        @click.prevent="!canAccess(item) && onDenied(item)"
      >
        <div class="card-icon"><img :src="item.iconSrc" alt="" /></div>
        <div class="card-title">{{ $t(item.titleKey) }}</div>
      </router-link>
    </section>

    <section
      v-if="visibleShortcuts[1].length"
      class="shortcuts_second_row"
      :style="{ gridTemplateColumns: 'repeat(' + visibleShortcuts[1].length + ', minmax(160px, 1fr))' }"
    >
      <router-link
        v-for="item in visibleShortcuts[1]"
        :key="item.href"
        :is="canAccess(item) ? 'router-link' : 'div'"
        :to="canAccess(item) ? item.href : null"
        class="shortcut-card"
        :class="{ 'shortcut-card--disabled': !canAccess(item) }"
        @click.prevent="!canAccess(item) && onDenied(item)"
      >
        <div class="card-icon"><img :src="item.iconSrc" alt="" /></div>
        <div class="card-title">{{ $t(item.titleKey) }}</div>
      </router-link>
    </section>

    <fieldset v-if="visibleAccountActions.length" class="account-panel">
      <div class="account-panel-title">{{ $t("account").toUpperCase() }}</div>
      <div class="panel-actions">
        <router-link
          v-for="a in visibleAccountActions"
          :key="a.href"
          :is="canAccess(a) ? 'router-link' : 'div'"
          :to="canAccess(a) ? a.href : null"
          class="panel-action"
          :class="{ 'panel-action--disabled': !canAccess(a) }"
          @click.prevent="!canAccess(a) && onDenied(a)"
        >
          <div class="pa-icon"><img :src="a.iconSrc" alt="" /></div>
          <div class="pa-title">{{ $t(a.titleKey) }}</div>
        </router-link>
      </div>
    </fieldset>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import "moment/locale/hu";
import "moment/locale/ro";
import { permissions, hasModuleAccess } from "~/helpers/Permissions";

export default {
  name: "LandingPage",
  data() {
    return {
      q: "",
      todayWeekday: "",
      todayFull: "",
      shortcuts: [
        [
          {
            href: "/tools/ai-chat",
            titleKey: "ai_assistant.title",
            iconSrc: require("@/assets/images/desktop/icons/brand-green/ai-assistant.svg"),
            permission: permissions.AI_CHAT,
            visibleIfDisabled: false,
          },
          {
            href: "/works/applyArticles?showMapp=true",
            titleKey: "map.title",
            iconSrc: require("@/assets/images/icons/pin.svg"),
            permission: permissions.DIGITAL_AGENDA,
          },
          {
            href: "/works/work-list",
            titleKey: "common.works",
            iconSrc: require("@/assets/images/desktop/icons/works_2.svg"),
            permission: permissions.WORKS,
          },
          {
            href: "/stock-management/sm-stocks",
            titleKey: "stock_management.title",
            iconSrc: require("@/assets/images/desktop/icons/stock-management_2.svg"),
            permission: permissions.SM_STOCK,
          },
          {
            href: "/scale/weighing-on-scale",
            titleKey: "common.scale",
            iconSrc: require("@/assets/images/desktop/icons/scale.svg"),
            permission: permissions.WEIGHING_ON_SCALE,
          },
        ],
        [
          {
            href: "/scouting/admin",
            titleKey: "scouting.title",
            iconSrc: require("@/assets/images/desktop/icons/scouting.svg"),
            permission: permissions.SCOUTINGS,
          },
          {
            href: "/reporting/management-board",
            titleKey: "reporting.management_board.title",
            iconSrc: require("@/assets/images/desktop/icons/apia.svg"),
            permission: permissions.MANAGEMENT_BOARD,
          },
          {
            href: "/reporting/report-list",
            titleKey: "common.reports",
            iconSrc: require("@/assets/images/desktop/icons/report.svg"),
            permission: permissions.REPORTS,
          },
          {
            href: "/arenda-management/contracts",
            titleKey: "common.arenda",
            iconSrc: require("@/assets/images/desktop/icons/field-contract-management.svg"),
            permission: permissions.ARENDA_CONTRACTS_ADMIN,
          },
          {
            href: "/salary-calculator/reports",
            titleKey: "common.salary_calculator",
            iconSrc: require("@/assets/images/desktop/icons/salary-calculator_2.svg"),
            permission: permissions.SC_REPORTS,
          },
          /*{
            href: "/apia/fertilization-plan",
            title: this.$t("common.register"),
            iconSrc: require("@/assets/images/desktop/icons/apia.svg"),
            permission: permissions.APIA,
          },*/
        ],
      ],
      accountActions: [
        {
          href: "/users",
          titleKey: "user_management",
          iconSrc: require("@/assets/images/desktop/icons/user-management.svg"),
          permission: permissions.USER_MANAGEMENT,
        },
        {
          href: "/roles-permissions",
          titleKey: "roles_permissions",
          iconSrc: require("@/assets/images/desktop/icons/role-permission.svg"),
          permission: permissions.ROLES_PERMISSIONS,
        },
        {
          href: "/tools/import",
          titleKey: "import",
          iconSrc: require("@/assets/images/desktop/icons/import.svg"),
          permission: permissions.IMPORT,
        },
        /*{
          href: "/tools/justifying-documents",
          title: "Export",
          iconSrc: require("@/assets/images/desktop/icons/export.svg"),
          permission: permissions.JUSTIFYING_DOCUMENTS,
        },*/
        {
          href: "/tools/settings",
          titleKey: "common.settings",
          iconSrc: require("@/assets/images/desktop/icons/controls/cog-gray.svg"),
          permission: permissions.SETTINGS,
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      user: "auth/user",
    }),
    firstName() {
      return (this.$store.getters["auth/user"]?.name || "").split(" ")[0] || this.$t("common.user");
    },
    visibleShortcuts() {
      return this.shortcuts.map((row) => row.filter((item) => this.isVisible(item)));
    },
    visibleAccountActions() {
      return this.accountActions.filter((item) => this.isVisible(item));
    },
  },
  mounted() {
    this.updateTodayStrings();
  },
  methods: {
    async updateTodayStrings() {
      try {
        const generalSettings = this.$store.getters["settings/generalSettings"] || [];
        if (!generalSettings.length) {
          await this.$store.dispatch("settings/getSettingsForGeneralUsage");
        }
      } catch (error) {
        // Ignore settings errors and fall back to default locale.
      }

      const locale = (this.$i18n?.locale || this.$store.getters["auth/user"]?.lang || "en").toLowerCase();
      const baseLocale = locale.split("-")[0] || "en";
      this.todayWeekday = moment().locale(baseLocale).format("dddd");
      this.todayFull = moment().locale(baseLocale).format("D MMMM YYYY");
    },
    canAccess(item) {
      return !item.permission || hasModuleAccess(this.user, item.permission);
    },
    isVisible(item) {
      return this.canAccess(item) || item.visibleIfDisabled !== false;
    },
    onDenied(item) {
      // Optional: toast or silent
      this.$refs?.toastMessage?.showError?.(this.$t("common.no_permission"));
    },
    onSearch() {
      /* optional */
    },
    onOpenFilters() {
      /* optional */
    },
  },
  watch: {
    "$i18n.locale"() {
      this.updateTodayStrings();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/global/colors.scss";

.landing {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  width: 100%;
  height: calc(100vh - 60px);
  margin-top: 4px;
  background: linear-gradient(135deg, #f7f7f7 0%, #e4efe8 100%);
  overflow: auto;

  /*background-image: linear-gradient(135deg, #ffffff 0%, #cffade 100%);
  background-size: 200% 200%;
  animation: gradient-pan 18s ease-in-out infinite;
  background-attachment: fixed;*/
}
/*
@keyframes gradient-pan {
  0%   { background-position:   0% 100%; }
  50%  { background-position: 100%   0%; }
  100% { background-position:   0% 100%; }
}*/
.hero {
  text-align: center;
  border-radius: 16px;
  padding-top: 72px;
  padding-bottom: 48px;
}
.greeting {
  margin: 0 0 6px 0;
  font-size: 24px;
}
.hi {
  color: $brand;
  font-weight: 700;
  margin-right: 4px;
}
.today {
  font-weight: 700;
}
.subtitle {
  color: $gray-50;
  font-size: 14px;
}
.search {
  display: flex;
  justify-content: center;
}
.search-box {
  width: min(760px, 92%);
  display: flex;
  align-items: center;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 28px;
  padding: 10px 12px;
}
.icon-search {
  width: 18px;
  height: 18px;
  margin-right: 8px;
  background: url("~@/assets/images/desktop/icons/search.svg") no-repeat center/contain;
}
.search-box input {
  flex: 1;
  border: 0;
  background: transparent;
  font-size: 14px;
}
.filter-btn {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  border: 0;
  background: #e9f6ee;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.shortcuts {
  display: grid;
  gap: 32px;
  justify-items: center;
  max-width: 1028px;
}
.shortcuts_second_row {
  display: grid;
  gap: 32px;
  justify-items: center;
  max-width: 1028px;
}

.shortcut-card {
  width: 100%;
  max-width: 180px;
  min-height: 160px;
  border-radius: 8px;
  background: #fff;
  border: 1px solid #eef0f2;
  box-shadow: 0px 24px 48px -12px #2755351a;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #1f2937;
  text-decoration: none;
}
.shortcut-card:hover {
  border: 1px solid $brand;
}
.card-icon {
  width: 56px;
  height: 56px;
  border-radius: 8px;
  background: $primary-color;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
}
.card-icon img {
  width: 26px;
  height: 24px;
  filter: brightness(0) invert(1);
}
.card-title {
  font-size: 14px;
  font-weight: 600;
  color: $gray-90;
  text-align: center;
}
.account-panel {
  position: relative;
  border: 1px solid #bebebe;
  border-radius: 8px;
  padding: 12px;
  margin: 0;
  margin-top: auto; /* pushes it to the bottom */
  margin-bottom: 96px; /* keep bottom flush (extra space comes from landing padding) */
}
.account-panel-title {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, -50%); /* half above the border */
  background: #e9f3ec; /* mask the border behind the text */
  padding: 0 12px;
  font-weight: 700;
  letter-spacing: 0.06em;
  font-size: 10px;
  line-height: 1;
  color: $gray-50;
  pointer-events: none; /* title not clickable */
  white-space: nowrap;
  border-radius: 8px;
}
.panel-actions {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
}
.panel-action {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: $gray-50;
  text-decoration: none;
  padding: 10px 6px;
  border-radius: 8px;
}
.pa-icon {
  width: 30px;
  height: 30px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 6px;
}
.pa-icon img {
  width: 24px;
  height: 24px;
}
.pa-title {
  font-size: 10px;
  font-weight: 500;
  text-align: center;
  color: $gray-70;
}

.shortcut-card--disabled,
.panel-action--disabled {
  opacity: 0.45;
  cursor: not-allowed;
  filter: grayscale(1);
  pointer-events: none; /* ensures no navigation */
}

.shortcut-card--disabled .card-icon {
  background: #cfd4d0;
}

.shortcut-card--disabled .card-title,
.panel-action--disabled .pa-title {
  color: $gray-40;
}

.shortcut-card--disabled:hover {
  transform: none;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.06);
}

.panel-action--disabled {
  filter: grayscale(1);
  opacity: 0.5;
}
</style>
